import {
  PROFORMA_INVOICE_LIST,
  PROFORMA_INVOICE_LIST_SUCCESS,
  PROFORMA_INVOICE_LIST_FAILURE,
  PROFORMA_INVOICE_LIST_SEARCH,
  PROFORMA_INVOICE_LIST_SEARCH_SUCCESS,
  PROFORMA_INVOICE_LIST_SEARCH_FAILURE,
  PROFORMA_INVOICE_DATA,
  PROFORMA_INVOICE_DATA_SUCCESS,
  PROFORMA_INVOICE_DATA_FAILURE,
  PROFORMA_INVOICE_CREATE,
  PROFORMA_INVOICE_CREATE_SUCCESS,
  PROFORMA_INVOICE_CREATE_FAILURE,
  PROFORMA_INVOICE_UPDATE,
  PROFORMA_INVOICE_UPDATE_SUCCESS,
  PROFORMA_INVOICE_UPDATE_FAILURE,
  PROFORMA_INVOICE_VOID,
  PROFORMA_INVOICE_VOID_SUCCESS,
  PROFORMA_INVOICE_VOID_FAILURE,
  PROFORMA_INVOICE_ITEM_SEARCH,
  PROFORMA_INVOICE_ITEM_SEARCH_SUCCESS,
  PROFORMA_INVOICE_ITEM_SEARCH_FAILURE,
  PROFORMA_INVOICE_ITEM_LIST,
  PROFORMA_INVOICE_ITEM_LIST_SUCCESS,
  PROFORMA_INVOICE_ITEM_LIST_FAILURE,
  PROFORMA_INVOICE_STATUS_LIST,
  PROFORMA_INVOICE_STATUS_LIST_SUCCESS,
  PROFORMA_INVOICE_STATUS_LIST_FAILURE,
  PROFORMA_INVOICE_STATUS_DATA,
  PROFORMA_INVOICE_STATUS_DATA_SUCCESS,
  PROFORMA_INVOICE_STATUS_DATA_FAILURE,
  PROFORMA_INVOICE_STATUS_CREATE,
  PROFORMA_INVOICE_STATUS_CREATE_SUCCESS,
  PROFORMA_INVOICE_STATUS_CREATE_FAILURE,
  PROFORMA_INVOICE_STATUS_UPDATE,
  PROFORMA_INVOICE_STATUS_UPDATE_SUCCESS,
  PROFORMA_INVOICE_STATUS_UPDATE_FAILURE,
  PROFORMA_INVOICE_STATUS_DELETE,
  PROFORMA_INVOICE_STATUS_DELETE_SUCCESS,
  PROFORMA_INVOICE_STATUS_DELETE_FAILURE,
  PROFORMA_INVOICE_PDF,
  PROFORMA_INVOICE_PDF_SUCCESS,
  PROFORMA_INVOICE_PDF_FAILURE,
  PROFORMA_INVOICE_EMAIL_SEND_AUTOMATED,
  PROFORMA_INVOICE_EMAIL_SEND_AUTOMATED_SUCCESS,
  PROFORMA_INVOICE_EMAIL_SEND_AUTOMATED_FAILURE,
  PROFORMA_INVOICE_EMAIL_RESEND_AUTOMATED,
  PROFORMA_INVOICE_EMAIL_RESEND_AUTOMATED_SUCCESS,
  PROFORMA_INVOICE_EMAIL_RESEND_AUTOMATED_FAILURE,
  PROFORMA_INVOICE_CONVERT_TO_INVOICE,
  PROFORMA_INVOICE_CONVERT_TO_INVOICE_SUCCESS,
  PROFORMA_INVOICE_CONVERT_TO_INVOICE_FAILURE,
  PROFORMA_INVOICE_SEARCH,
  PROFORMA_INVOICE_SEARCH_SUCCESS,
  PROFORMA_INVOICE_SEARCH_FAILURE,
  PROFORMA_INVOICE_ACTIVITY_LOG_SEARCH,
  PROFORMA_INVOICE_ACTIVITY_LOG_SEARCH_SUCCESS,
  PROFORMA_INVOICE_ACTIVITY_LOG_SEARCH_FAILURE,
} from "./actionType";

//Actios

//Proforma Invoice List
export const proformaInvoiceList = () => ({
  type: PROFORMA_INVOICE_LIST,
});

export const proformaInvoiceListSuccess = (data) => ({
  type: PROFORMA_INVOICE_LIST_SUCCESS,
  payload: data,
});

export const proformaInvoiceListFailure = (error) => ({
  type: PROFORMA_INVOICE_LIST_FAILURE,
  payload: error,
});

//Proforma Invoice List Search
export const proformaInvoiceListSearch = (data) => ({
  type: PROFORMA_INVOICE_LIST_SEARCH,
  payload: data,
});

export const proformaInvoiceListSearchSuccess = (data) => ({
  type: PROFORMA_INVOICE_LIST_SEARCH_SUCCESS,
  payload: data,
});

export const proformaInvoiceListSearchFailure = (error) => ({
  type: PROFORMA_INVOICE_LIST_SEARCH_FAILURE,
  payload: error,
});

//Proforma Invoice Data
export const proformaInvoiceData = (data) => ({
  type: PROFORMA_INVOICE_DATA,
  payload: data,
});

export const proformaInvoiceDataSuccess = (data) => ({
  type: PROFORMA_INVOICE_DATA_SUCCESS,
  payload: data,
});

export const proformaInvoiceDataFailure = (error) => ({
  type: PROFORMA_INVOICE_DATA_FAILURE,
  payload: error,
});

//Proforma Invoice Create
export const proformaInvoiceCreate = (data) => ({
  type: PROFORMA_INVOICE_CREATE,
  payload: data,
});

export const proformaInvoiceCreateSuccess = (data) => ({
  type: PROFORMA_INVOICE_CREATE_SUCCESS,
  payload: data,
});

export const proformaInvoiceCreateFailure = (error) => ({
  type: PROFORMA_INVOICE_CREATE_FAILURE,
  payload: error,
});

//Proforma Invoice Update
export const proformaInvoiceUpdate = (data) => ({
  type: PROFORMA_INVOICE_UPDATE,
  payload: data,
});

export const proformaInvoiceUpdateSuccess = (data) => ({
  type: PROFORMA_INVOICE_UPDATE_SUCCESS,
  payload: data,
});

export const proformaInvoiceUpdateFailure = (error) => ({
  type: PROFORMA_INVOICE_UPDATE_FAILURE,
  payload: error,
});

//Proforma Invoice Void
export const proformaInvoiceVoid = (data) => ({
  type: PROFORMA_INVOICE_VOID,
  payload: data,
});

export const proformaInvoiceVoidSuccess = (data) => ({
  type: PROFORMA_INVOICE_VOID_SUCCESS,
  payload: data,
});

export const proformaInvoiceVoidFailure = (error) => ({
  type: PROFORMA_INVOICE_VOID_FAILURE,
  payload: error,
});

//Proforma Invoice Item Search
export const proformaInvoiceItemSearch = (data) => ({
  type: PROFORMA_INVOICE_ITEM_SEARCH,
  payload: data,
});

export const proformaInvoiceItemSearchSuccess = (data) => ({
  type: PROFORMA_INVOICE_ITEM_SEARCH_SUCCESS,
  payload: data,
});

export const proformaInvoiceItemSearchFailure = (error) => ({
  type: PROFORMA_INVOICE_ITEM_SEARCH_FAILURE,
  payload: error,
});

//Proforma Invoice Item List
export const proformaInvoiceItemList = () => ({
  type: PROFORMA_INVOICE_ITEM_LIST,
});

export const proformaInvoiceItemListSuccess = (data) => ({
  type: PROFORMA_INVOICE_ITEM_LIST_SUCCESS,
  payload: data,
});

export const proformaInvoiceItemListFailure = (error) => ({
  type: PROFORMA_INVOICE_ITEM_LIST_FAILURE,
  payload: error,
});

//Proforma Invoice Status List
export const proformaInvoiceStatusList = () => ({
  type: PROFORMA_INVOICE_STATUS_LIST,
});

export const proformaInvoiceStatusListSuccess = (data) => ({
  type: PROFORMA_INVOICE_STATUS_LIST_SUCCESS,
  payload: data,
});

export const proformaInvoiceStatusListFailure = (error) => ({
  type: PROFORMA_INVOICE_STATUS_LIST_FAILURE,
  payload: error,
});

//Proforma Invoice Status Data
export const proformaInvoiceStatusData = (data) => ({
  type: PROFORMA_INVOICE_STATUS_DATA,
  payload: data,
});

export const proformaInvoiceStatusDataSuccess = (data) => ({
  type: PROFORMA_INVOICE_STATUS_DATA_SUCCESS,
  payload: data,
});

export const proformaInvoiceStatusDataFailure = (error) => ({
  type: PROFORMA_INVOICE_STATUS_DATA_FAILURE,
  payload: error,
});

//Proforma Invoice Status Create
export const proformaInvoiceStatusCreate = (data) => ({
  type: PROFORMA_INVOICE_STATUS_CREATE,
  payload: data,
});

export const proformaInvoiceStatusCreateSuccess = (data) => ({
  type: PROFORMA_INVOICE_STATUS_CREATE_SUCCESS,
  payload: data,
});

export const proformaInvoiceStatusCreateFailure = (error) => ({
  type: PROFORMA_INVOICE_STATUS_CREATE_FAILURE,
  payload: error,
});

//Proforma Invoice Status Update
export const proformaInvoiceStatusUpdate = (data) => ({
  type: PROFORMA_INVOICE_STATUS_UPDATE,
  payload: data,
});

export const proformaInvoiceStatusUpdateSuccess = (data) => ({
  type: PROFORMA_INVOICE_STATUS_UPDATE_SUCCESS,
  payload: data,
});

export const proformaInvoiceStatusUpdateFailure = (error) => ({
  type: PROFORMA_INVOICE_STATUS_UPDATE_FAILURE,
  payload: error,
});

//Proforma Invoice Status Delete
export const proformaInvoiceStatusDelete = (data) => ({
  type: PROFORMA_INVOICE_STATUS_DELETE,
  payload: data,
});

export const proformaInvoiceStatusDeleteSuccess = (data) => ({
  type: PROFORMA_INVOICE_STATUS_DELETE_SUCCESS,
  payload: data,
});

export const proformaInvoiceStatusDeleteFailure = (error) => ({
  type: PROFORMA_INVOICE_STATUS_DELETE_FAILURE,
  payload: error,
});

//Proforma Invoice PDF
export const proformaInvoicePDF = (data) => ({
  type: PROFORMA_INVOICE_PDF,
  payload: data,
});

export const proformaInvoicePDFSuccess = (data) => ({
  type: PROFORMA_INVOICE_PDF_SUCCESS,
  payload: data,
});

export const proformaInvoicePDFFailure = (error) => ({
  type: PROFORMA_INVOICE_PDF_FAILURE,
  payload: error,
});

//Proforma Invoice Email Send Automated
export const proformaInvoiceEmailSendAutomated = (data) => ({
  type: PROFORMA_INVOICE_EMAIL_SEND_AUTOMATED,
  payload: data,
});

export const proformaInvoiceEmailSendAutomatedSuccess = (data) => ({
  type: PROFORMA_INVOICE_EMAIL_SEND_AUTOMATED_SUCCESS,
  payload: data,
});

export const proformaInvoiceEmailSendAutomatedFailure = (error) => ({
  type: PROFORMA_INVOICE_EMAIL_SEND_AUTOMATED_FAILURE,
  payload: error,
});

//Proforma Invoice Email Resend Automated
export const proformaInvoiceEmailResendAutomated = (data) => ({
  type: PROFORMA_INVOICE_EMAIL_RESEND_AUTOMATED,
  payload: data,
});

export const proformaInvoiceEmailResendAutomatedSuccess = (data) => ({
  type: PROFORMA_INVOICE_EMAIL_RESEND_AUTOMATED_SUCCESS,
  payload: data,
});

export const proformaInvoiceEmailResendAutomatedFailure = (error) => ({
  type: PROFORMA_INVOICE_EMAIL_RESEND_AUTOMATED_FAILURE,
  payload: error,
});

//Proforma Invoice Convert To Invoice
export const proformaInvoiceConvertToInvoice = (data) => ({
  type: PROFORMA_INVOICE_CONVERT_TO_INVOICE,
  payload: data,
});

export const proformaInvoiceConvertToInvoiceSuccess = (data) => ({
  type: PROFORMA_INVOICE_CONVERT_TO_INVOICE_SUCCESS,
  payload: data,
});

export const proformaInvoiceConvertToInvoiceFailure = (error) => ({
  type: PROFORMA_INVOICE_CONVERT_TO_INVOICE_FAILURE,
  payload: error,
});

//Proforma Invoice Search
export const proformaInvoiceSearch = (data) => ({
  type: PROFORMA_INVOICE_SEARCH,
  payload: data,
});

export const proformaInvoiceSearchSuccess = (data) => ({
  type: PROFORMA_INVOICE_SEARCH_SUCCESS,
  payload: data,
});

export const proformaInvoiceSearchFailure = (error) => ({
  type: PROFORMA_INVOICE_SEARCH_FAILURE,
  payload: error,
});

//Proforma Invoice Activity Log Search
export const proformaInvoiceActivityLogSearch = (data) => ({
  type: PROFORMA_INVOICE_ACTIVITY_LOG_SEARCH,
  payload: data,
});
export const proformaInvoiceActivityLogSearchSuccess = (data) => ({
  type: PROFORMA_INVOICE_ACTIVITY_LOG_SEARCH_SUCCESS,
  payload: data,
});
export const proformaInvoiceActivityLogSearchFailure = (error) => ({
  type: PROFORMA_INVOICE_ACTIVITY_LOG_SEARCH_FAILURE,
  payload: error,
});
